import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { CheckboxField, CheckboxGroup } from "../../components/catalyst/checkbox";
import { Fieldset, Legend } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";

function PanelServices() {
  const context = useNotaire();
  const initial = context.infoNotaire;

  const [services, setServices] = useState({
    whatsapp: initial.whatsapp === "True",
    visio: initial.visio === "True",
    signature: initial.signature === "True",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setServices((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fields = {
      whatsapp: services.whatsapp ? "True" : "False",
      visio: services.visio ? "True" : "False",
      signature: services.signature ? "True" : "False",
    };

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/info-notaire/${context.infoNotaire.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fields }),
        }
      );

      if (res.ok) {
        toast.success("Services mis à jour !");
      } else {
        const errText = await res.text();
        console.error("Erreur Airtable :", errText);
        toast.error("Erreur lors de la mise à jour.");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      toast.error("Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow mt-8">
      <Fieldset>
        <Legend>Services proposés</Legend>
        <CheckboxGroup>
          <CheckboxField>
            <input
              type="checkbox"
              name="whatsapp"
              checked={services.whatsapp}
              onChange={handleChange}
            />
            <span>J'utilise WhatsApp pour échanger avec mes clients</span>
          </CheckboxField>
          <CheckboxField>
            <input
              type="checkbox"
              name="visio"
              checked={services.visio}
              onChange={handleChange}
            />
            <span>Je fais des rendez-vous en visio</span>
          </CheckboxField>
          <CheckboxField>
            <input
              type="checkbox"
              name="signature"
              checked={services.signature}
              onChange={handleChange}
            />
            <span>J'utilise la signature électronique</span>
          </CheckboxField>
        </CheckboxGroup>
      </Fieldset>

      <button type="submit" className="btn-primary mt-4" disabled={loading}>
        {loading ? "Mise à jour..." : "Modifier les services"}
      </button>
    </form>
  );
}

export default PanelServices;